import React from 'lib/react';
import PropTypes from 'prop-types';
import {
  EVInputLabel,
  EVTextField,
} from 'lib/components';
import clsx from 'lib/clsx';

function TextInputField(props) {
  const {
    handleChange, helperText, inputFieldProps, inputId, inputLabelProps, inputValue, isRequired, labelText, size, InputProps, inputprops,
  } = props;
  const isError = Boolean(helperText || (isRequired && inputValue === ''));

  const { className: inputLabelClassName, ...restInputLabelProps } = inputLabelProps;

  return (
    <>
      {labelText && (
        <EVInputLabel required={isRequired} {...restInputLabelProps} className={clsx(inputLabelClassName, isError && 'error')}>
          {labelText}
        </EVInputLabel>
      )}
      <EVTextField
        fullWidth
        value={inputValue}
        error={isError}
        onChange={handleChange}
        id={inputId}
        variant="outlined"
        size={size}
        helperText={helperText || (isError && 'This field is required')}
        InputProps={InputProps}
        inputProps={inputprops}
        {...inputFieldProps}
      />
    </>
  );
}

TextInputField.defaultProps = {
  helperText: '',
  inputLabelProps: {},
  inputId: '',
  inputValue: '',
  inputFieldProps: {},
  isRequired: false,
  labelText: '',
  size: 'medium',
  InputProps: {},
  inputprops: {},
};

TextInputField.propTypes = {
  handleChange: PropTypes.func.isRequired,
  helperText: PropTypes.string,
  inputLabelProps: PropTypes.shape(),
  inputId: PropTypes.string,
  inputValue: PropTypes.string,
  inputFieldProps: PropTypes.shape(),
  isRequired: PropTypes.bool,
  labelText: PropTypes.string,
  size: PropTypes.string,
  InputProps: PropTypes.shape(),
  inputprops: PropTypes.shape(),
};
export default TextInputField;
